import { VeltComments, VeltCommentTool } from '@veltdev/react';
import './CommentsAreaPage.css';

function CommentsAreaPage() { 

    return (
        <>
            <VeltComments />
            <div className="comment-tool-container">
                <p className='boujeeText'>
                    Click the Comment Tool in the bottom right to add a comment anywhere. <br />
                    Click and Drag to add an area comment.
                </p>
                <VeltCommentTool />
            </div>
        </>
    )
}

export default CommentsAreaPage;